// Simple helper to try shortening a URL using TinyURL public API.
// Returns shortened URL string or original URL on failure.
export async function tryShorten(url) {
  if (!url) return url;
  try {
    const api = `https://tinyurl.com/api-create.php?url=${encodeURIComponent(url)}`;
    const res = await fetch(api);
    if (!res.ok) throw new Error('shorten-failed');
    const text = await res.text();
    // TinyURL returns the shortened url as plain text
    if (!text || !text.startsWith('http')) return url;
    return text;
  } catch (e) {
    // CORS or network errors will fall back to original URL
    return url;
  }
}

export default tryShorten;
